export function SurveyFeedbackAnswerViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    isElementEditable: false,

    angularTemplate: `
<div layout="row">
  <span>{{ elementData.score }}</span>
  <span class="alc-margin-right-16">:</span>
  <span flex>{{ elementData.label }}</span>
</div>
`,

  });
}
